import React, { useEffect } from 'react';
import useAppBarNavigationStore, { NavigationStates } from 'stores/app-bar-navigation-store';
import WebmeticsOverview from '../features/lead-list-research/webmetics/webmetics-integrations';

const WebmeticsLanding: React.FC = () => {
  const { setActiveTab } = useAppBarNavigationStore((state) => ({ setActiveTab: state.setActiveTab }));

  useEffect(() => {
    setActiveTab(NavigationStates.WEBMETICS_OVERVIEW);
  }, []);

  return <WebmeticsOverview />;
};

export default WebmeticsLanding;
